module.exports = __webpack_public_path__ + "static/media/empty_container.f5b36a1f.png";